import {LocalizeBadgeName, Tr} from "@/i18n/i18n";
import Container = Phaser.GameObjects.Container;
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import Image = Phaser.GameObjects.Image;
import {MenuNewElementMarker} from "@/scenes.ui/menu-new-element-marker";
import {Badge} from "@/store/profile/types";
import SpriteUtils from "@/utils/sprite-utils";
import PlayerStore from "@/store/player";
import {Lang} from "@/store/player/types";

export default class BadgePanel extends Container {

    private clickCallback: (() => unknown) | undefined = undefined;
    private mainImage: Image | undefined;

    private badge!: Badge;
    private newBadgeMarker!: MenuNewElementMarker;

    constructor(scene: Scene, x: number, y: number, badge: Badge) {
        super(scene);

        this.x = x;
        this.y = y;

        this.badge = badge;

        this.mainImage = SpriteUtils.addSprite(this.scene, 0, -2, Keys.ATLAS_BADGES, badge.rewardId).setInteractive();
        SpriteUtils.setDispSize(this.mainImage, 90, 90);
        let liner = SpriteUtils.addSprite(this.scene, 0, -2, Keys.ATLAS_UI, Keys.UI_BADGE_LINER);
        SpriteUtils.setDispSize(liner, 93, 93);
        let name = TextUtils.addTextAdvanced(this.scene,
            PlayerStore.getPlayer().lang != Lang.RU ? LocalizeBadgeName(badge.name).toUpperCase() : badge.name,
            0, this.mainImage.y + 50, '#c1c1c1',
            12, 'normal', 100, 'center', 2, Fonts.BENGALY_NORMAL);

        this.add([liner, this.mainImage, name]);

        if (badge.badgeNew) {
            this.newBadgeMarker = new MenuNewElementMarker(scene, 0, -40, Tr('novaja'));
            this.add(this.newBadgeMarker);
        }
    }

    public setClickCallback(callback: () => unknown): void {
        this.clickCallback = callback;

        this.mainImage!.on('pointerdown', () => {
            if (this.clickCallback != null) {
                this.clickCallback();
            }
        });
    }

    public getPanelBadge(): Badge {
        return this.badge;
    }
}
